import React, { useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { logoColor } from '../../ui/media';
import { useForgotPassword, useVerifyOtp } from '../../../hooks/useAuth';
import { useStore } from '@tanstack/react-store';
import { themeStore } from '../../../stores/theme';
import toast from 'react-hot-toast';

const OTPVerification = () => {
    const { isDarkMode } = useStore(themeStore)
    const { email } = useParams()
    const [otp, setOtp] = useState(new Array(6).fill(''));
    const navigate = useNavigate()
    const inputsRef = useRef([]);
    const verifyOtpMutation = useVerifyOtp()
    const ForgotMutation = useForgotPassword()

    const handleChange = (element, index) => {
        const value = element.value.replace(/[^0-9]/g, '');
        if (value) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (index < 5) {
                inputsRef.current[index + 1].focus();
            }
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (otp[index]) {
                const newOtp = [...otp];
                newOtp[index] = '';
                setOtp(newOtp);
            } else if (index > 0) {
                inputsRef.current[index - 1].focus();
            }
        } else if (e.key === 'ArrowLeft' && index > 0) {
            inputsRef.current[index - 1].focus();
        } else if (e.key === 'ArrowRight' && index < 5) {
            inputsRef.current[index + 1].focus();
        }
    };

    const handleSubmit = () => {
        const enteredOtp = otp.join('');
        if (enteredOtp?.length < 6) {
            toast.error("OTP should be of 6 Digits")
            return
        }
        verifyOtpMutation.mutate({ email: decodeURIComponent(email), otp: enteredOtp }, {
            onSuccess: () => {
                navigate(`/reset-password/${encodeURIComponent(email)}/${enteredOtp}`)
            },
            onError: (error) => {
                const message = error.response?.data?.message || "Server Error"
                toast.error(message)
            }
        })
    };

    const resendOtp = () => {
        ForgotMutation.mutate({ email: decodeURIComponent(email) }, {
            onSuccess: () => {
                setOtp(new Array(6).fill(''))
                inputsRef.current[0].focus();
                toast.success("OTP Resent Successfully.")
            },
            onError: (error) => {
                const message = error.response?.data?.message || "Server Error"
                toast.error(message)
            }
        })
    }

    const Logo = () => {
        return (
            <div className="flex flex-col items-center">
                <img src={logoColor} className='h-[70px]' />
            </div>
        );
    };

    return (
        <div className={`min-h-screen flex items-center justify-center p-4`}>
            <div className={`w-full max-w-md rounded-lg shadow-lg overflow-hidden ${isDarkMode ? 'bg-gray-800' : 'bg-white'}`}>
                {/* Logo Header */}
                <div className="bg-blue-100 w-[95%] mx-auto my-3 rounded-lg p-6 flex justify-center">
                    <div className="flex flex-col items-center">
                        <Logo />
                    </div>
                </div>
                <h1 className={`text-2xl poppins-regular font-bold mt-4 text-center ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>Verification</h1>
                <p className={`text-sm mt-2 text-center ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>
                    Please enter 6-digit pin sent on your<br />
                    registered email address
                </p>
                <div className="p-6 text-center">
                    <p className={`${isDarkMode ? 'text-white' : 'text-gray-600'} mb-3`}>Verification Code</p>
                    <div className="flex justify-center space-x-3 mb-6">
                        {otp.map((digit, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength={1}
                                value={digit}
                                onChange={(e) => handleChange(e.target, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                ref={(el) => (inputsRef.current[index] = el)}
                                className={`w-12 h-12 text-center text-xl font-bold rounded border outline-none focus:ring-2 ${isDarkMode
                                    ? 'bg-gray-700 border-gray-600 text-white focus:ring-blue-400'
                                    : 'bg-white border-gray-300 text-black focus:ring-blue-600'
                                    }`}
                            />
                        ))}
                    </div>
                    <button
                        onClick={handleSubmit}
                        disabled={verifyOtpMutation.isLoading ? true : false}
                        className="w-[250px] poppins-regular bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full">
                        {verifyOtpMutation.isLoading ? "Verifying...." : "Verify and Continue"}
                    </button>
                    <p className={`mt-2 poppins-regular text-xs ${isDarkMode ? 'text-white' : 'text-gray-600'}`}>Didn’t receive the code? <span
                        onClick={() => resendOtp()}
                        className='font-normal cursor-pointer text-blue-500'>Resend</span></p>
                </div>
            </div>
        </div>
    );
};
export default OTPVerification;